<template>
  <div class="formBox">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormBox',
  props: {
    labeltxt: {
      type: [String],
    },
    required: {
      type: [Boolean],
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.formBox {
  width: 100%;
  background-color: $secondaryGray;
  @include pad-width() {
    display: flex;
  }

  > div {
    flex: 1;
  }
}
</style>
